import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    "en": {
      "cart": {
        "item": {
          "remove": "Távolítsa el a",
          "closeEdit": "Bezár",
          "edit": "Szerkesztés"
        },
        "updating": "Frissítés",
        "checkout": "Pénztár",
        "accountBalance": "Számlaegyenleg",
        "total": "Összesen",
        "taxes": "Adók",
        "discounts": "Kedvezmények",
        "shipping": "Szállítás",
        "subtotal": "Részösszeg",
        "giftCard": "{amount} kártya",
        "applyCoupon": "Alkalmazza a kupont",
        "backToProducts": "Vásároljon most",
        "empty": "A kosara üres.",
        "title": "Kosár",
        "exceedsStockLevel": "Nem tud többet hozzáadni, mint amennyi ebből a termékből rendelkezésre áll.",
        "infoText": ""
      },
      "errors": {
        "categoryNotFound": "Kategória nem található",
        "pageNotFound": {
          "message": "Lehet, hogy a link, amelyre rákattintott, megváltozott, vagy az URL helytelen. Próbálja meg a keresést?",
          "title": "Oldal nem található"
        },
        "internal": {
          "reload": "Újratölteni az oldalt",
          "message": "Valami rosszul sült el, de a problémát naplóztuk, és utánanézünk.",
          "title": "Belső szerverhiba"
        },
        "returnHome": "Vissza a főoldalra",
        "errorCode": "{code} "
      },
      "emailSignup": {
        "email": {
          "error": "Ez nem úgy néz ki, mint egy e-mail..."
        },
        "success": "Rajta vagy a listán!",
        "placeholder": "E-mail",
        "send": "Küldje el a"
      },
      "notifications": {
        "cookies": {
          "privacy": "További információk",
          "message": "Sütiket használunk a vásárlási élmény javítása érdekében.",
          "close": "Bezár"
        },
        "cart": "Kosár megtekintése",
        "checkout": "Pénztár"
      },
      "navigation": {
        "account": "Számla",
        "search": "Keresés",
        "menu": "Menü"
      },
      "search": {
        "info": "Kereséshez nyomja meg az Entert",
        "placeholder": "pl. termékmodell",
        "title": "Termék keresése"
      },
      "products": {
        "preview": {
          "save": "Megtakarítás",
          "sale": "Akciós",
          "quickAdd": {
            "adding": {
              "loadingLabel": "Hozzáadás...",
              "label": "Hozzáadás..."
            },
            "addToCart": "Hozzáadás a kosárhoz",
            "quickAdd": "Gyors hozzáadás",
            "quickView": "Gyors megtekintés",
            "outOfStock": "Ez a termék már nincs raktáron."
          }
        },
        "slug": {
          "share": "Ossza meg",
          "updating": "Frissítés",
          "save": "Mentés",
          "addToCart": "Hozzáadás a kosárhoz",
          "stockRemaining": "Maradék{n} ",
          "options": {
            "required": "Kérjük, adjon meg egy értéket."
          },
          "stockStatus": {
            "outOfStock": {
              "message": "",
              "label": "Nincs készleten"
            },
            "limitedAvailability": {
              "message": "1-2 napon belül szállítható",
              "label": "Kevés készleten"
            },
            "inStock": {
              "message": "1-2 napon belül szállítható",
              "label": "Készleten"
            },
            "custom": {
              "message": "9-16 napon belül szállítható",
              "label": "Egyedi megrendelés"
            }
          },
          "purchaseOptions": {
            "interval": {
              "daily": {
                "label": "nap | nap | nap",
                "short": "nap"
              },
              "weekly": {
                "label": "hét | hét | hét",
                "short": "wk"
              },
              "monthly": {
                "label": "hónapok | hónap | hónapok",
                "short": "mo"
              },
              "yearly": {
                "label": "év | év | év",
                "short": "yr"
              },
              "productsInterval": "{count} minden {n} {interval}"
            },
            "standard": {
              "defaultLabel": "Egyszeri vásárlás"
            }
          }
        }
      },
      "categories": {
        "slug": {
          "pagination": {
            "page": "Oldal {currentPage} / {pagesCount}",
            "next": "Következő",
            "previous": "Előző"
          },
          "apply": "Szűrők alkalmazása",
          "clear": "Törölje az összeset",
          "refine": "Szűrési feltételek",
          "editFilters": "Szűrők szerkesztése",
          "categoryProductsNotFound": "Ebben a kategóriában nem találtunk terméket.",
          "filterProductsNotFound": "Nem találtunk az Ön által megadott kritériumoknak megfelelő terméket.",
          "sortModes": {
            "priceDesc": "Ár (csökkenő)",
            "priceAsc": "Ár (növekvő)",
            "popularity": "Legnépszerűbb",
            "latest": "Legújabb"
          },
          "sort": "Rendezés",
          "productsCount": "{n} termék | {n} termék | {n} termék",
          "filters": "Szűrők"
        }
      },
      "account": {
        "payments": {
          "popup": {
            "delete": {
              "error": "Probléma merült fel a kártya törlésével.",
              "success": "A kártya törlésre került.",
              "button": {
                "loadingLabel": "Törlés",
                "label": "Kártya törlése"
              }
            },
            "save": {
              "error": "Probléma merült fel a fizetési mód frissítésével kapcsolatban.",
              "success": "Fizetési mód frissítése.",
              "button": {
                "loadingLabel": "Mentés",
                "label": "Kártya mentése"
              }
            },
            "create": {
              "error": "Probléma adódott a fizetési mód hozzáadásával.",
              "success": "Fizetési mód létrehozása.",
              "button": {
                "loadingLabel": "Hozzáadás",
                "label": "Új fizetési mód hozzáadása"
              }
            },
            "newBillingAddress": "Új cím hozzáadása",
            "noBillingAddress": "Nincsenek meglévő címei. Hozzon létre egyet az alábbiakban.",
            "billingAddress": "Számlázási cím",
            "card": {
              "setAsDefault": "Alapértelmezett kártyaként használja."
            },
            "cvc": {
              "format": "Adjon meg egy érvényes kártyabiztonsági kódot.",
              "required": "Kérjük, adja meg a kártya biztonsági kódját.",
              "label": "CVC"
            },
            "cardExpiry": {
              "date": "Adjon meg egy érvényes lejárati dátumot.",
              "required": "Adja meg a kártya lejárati dátumát.",
              "label": "Kártya lejárati ideje"
            },
            "cardNumber": {
              "maxLength": "Kérjük, adjon meg egy érvényes kártyaszámot.",
              "required": "Kérjük, adja meg a kártyaszámot.",
              "label": "Kártyaszám"
            },
            "edit": {
              "title": "Fizetési mód szerkesztése"
            },
            "new": {
              "title": "Új fizetési mód hozzáadása"
            }
          },
          "card": {
            "edit": "Szerkesztés",
            "noBillingAddress": "Még nincs hozzárendelt számlázási cím.",
            "billingAddress": "Számlázási cím",
            "default": "Alapértelmezett"
          },
          "addPaymentMethod": "Új fizetési mód hozzáadása",
          "noPaymentMethods": "Ehhez a számlához nincsenek fizetési módok társítva.",
          "title": "Fizetési módok"
        },
        "login": {
          "error": "Az e-mail címe vagy jelszava rosszul lett megadva.",
          "success": "Sikeresen bejelentkezett.",
          "button": {
            "loadingLabel": "Bejelentkezés",
            "label": "Bejelentkezés"
          },
          "createAccount": "Fiók létrehozása",
          "forgotPassword": "Elfelejtette a jelszavát?",
          "password": {
            "required": "Kérjük, adja meg jelszavát.",
            "placeholder": "Az Ön jelszava",
            "label": "Jelszó"
          },
          "email": {
            "format": "Kérjük, adjon meg egy érvényes e-mail címet.",
            "required": "Kérjük, adja meg az e-mail címét.",
            "placeholder": "E-mail",
            "label": "E-mail"
          },
          "title": "Bejelentkezés",
          "notLoggedIn": "Ön jelenleg nincs bejelentkezve. Kérjük, jelentkezzen be a folytatáshoz."
        },
        "resetPassword": {
          "error": "Hiba történt a jelszava frissítésében. Lehet, hogy a jelszó visszaállításának kulcsa lejárt.",
          "success": "Sikeresen frissítette jelszavát.",
          "button": {
            "loadingLabel": "Feldolgozás...",
            "label": "Jelszó módosítása"
          },
          "confirmPassword": {
            "notMatch": "A jelszavak nem egyeznek.",
            "placeholder": "Új jelszó megerősítése"
          },
          "password": {
            "minLength": "A jelszónak legalább {n} karaktert kell tartalmaznia.",
            "required": "Kérjük, adja meg a jelszavát.",
            "hint": "Legalább {n} karaktert kell tartalmaznia.",
            "placeholder": "Az Ön jelszava",
            "label": "Jelszó"
          },
          "infoText": "Kérjük, adja meg új jelszavát.",
          "title": "Jelszó módosítása"
        },
        "forgotPassword": {
          "error": "Hiba történt a jelszó visszaállítása során.",
          "success": "A jelszó visszaállítására egy e-mailt küldtünk.",
          "logIn": "Vissza a bejelentkezéshez",
          "button": {
            "loadingLabel": "Küldés...",
            "label": "E-mail küldése"
          },
          "email": {
            "format": "Kérjük, adjon meg egy érvényes e-mail címet.",
            "required": "Kérjük, adja meg az e-mail címét.",
            "placeholder": "E-mail",
            "label": "E-mail"
          },
          "infoText": "Add meg az e-mail címedet, és küldünk egy e-mailt arról, hogyan állíthatod vissza a jelszavadat.",
          "title": "Elfelejtette jelszavát?"
        },
        "createAccount": {
          "error": "Hiba történt a fiók létrehozása során. Kérjük, próbálja meg később újra.",
          "alreadyExists": "Ezen az e-mail címen már létezik fiók. Kérjük, jelentkezzen be.",
          "success": "Sikeresen létrehozott egy fiókot.",
          "logIn": "Bejelentkezés",
          "button": {
            "loadingLabel": "A  létrehozása",
            "label": "Fiók létrehozása"
          },
          "password": {
            "minLength": "A jelszavadnak legalább {n} karaktereknek kell lennie.",
            "required": "Kérjük, adja meg jelszavát.",
            "hint": "Legalább {n} karaktert kell tartalmaznia.",
            "placeholder": "Az Ön jelszava",
            "label": "Jelszó"
          },
          "email": {
            "format": "Kérjük, adjon meg egy érvényes e-mail címet.",
            "required": "Kérjük, adja meg az e-mail címét.",
            "placeholder": "E-mail",
            "label": "E-mail"
          },
          "lastName": {
            "maxLength": "A vezetéknév nem haladhatja meg az {n} karaktert.",
            "required": "Kérjük, adja meg a vezetéknevét.",
            "label": "Vezetéknév"
          },
          "firstName": {
            "maxLength": "A keresztnév nem haladhatja meg a {n} karaktert.",
            "required": "Kérjük, adja meg a keresztnevét.",
            "label": "Keresztnév"
          },
          "title": "Fiók létrehozása"
        },
        "addresses": {
          "popup": {
            "delete": {
              "error": "Hiba történt a cím törlésében.",
              "success": "A cím törlésre került.",
              "button": {
                "loadingLabel": "Cím törlése",
                "label": "Cím törlése"
              }
            },
            "save": {
              "error": "Hiba történt a cím frissítésében.",
              "success": "A cím frissítése.",
              "button": {
                "loadingLabel": "Cím mentése",
                "label": "Cím mentése"
              }
            },
            "create": {
              "error": "Hiba történt a cím frissítésében.",
              "success": "Cím létrehozva.",
              "button": {
                "loadingLabel": "Cím létrehozása",
                "label": "Cím létrehozása"
              }
            },
            "setAsDefault": "Legyen ez az alapértelmezett szállítási címem.",
            "country": {
              "required": "Kérjük, adja meg az országot.",
              "label": "Ország"
            },
            "zipCode": {
              "required": "Kérjük, adja meg az irányítószámát.",
              "label": "Irányítószám"
            },
            "region": {
              "required": "Kérjük, adja meg a régiót.",
              "label": "Régió"
            },
            "city": {
              "required": "Kérjük, adja meg a várost.",
              "label": "Város"
            },
            "phone": {
              "format": "Kérjük, adjon meg egy érvényes telefonszámot.",
              "label": "telefon"
            },
            "address2": {
              "label": "Apartman / emelet / lakosztály"
            },
            "address1": {
              "required": "Kérjük, adja meg a címét.",
              "label": "Cím"
            },
            "lastName": {
              "maxLength": "A vezetéknév nem haladhatja meg a {n} karaktert.",
              "required": "Kérjük, adja meg a vezetéknevét.",
              "label": "Vezetéknév"
            },
            "firstName": {
              "maxLength": "A keresztnév nem haladhatja meg a {n} karaktert.",
              "required": "Kérjük, adja meg a keresztnevét.",
              "label": "Keresztnév"
            },
            "edit": {
              "title": "Cím szerkesztése"
            },
            "new": {
              "title": "Új cím hozzáadása"
            }
          },
          "edit": "Szerkesztés",
          "remove": "Távolítsa el a",
          "useAsDefault": "Alapértelmezettként használni",
          "default": "Alapértelmezett",
          "setDefaultAddress": {
            "success": "Alapértelmezettként beállított cím.",
            "loading": "Alapértelmezettként való beállítás",
            "no": "Nincs",
            "yes": "Igen",
            "text": "Biztos, hogy ezt a címet szeretné alapértelmezetté tenni?",
            "title": "Alapértelmezett cím beállítása"
          },
          "deleteAddress": {
            "success": "A cím törlésre került.",
            "loading": "A  eltávolítása",
            "no": "Nem, tartsa meg.",
            "yes": "Igen, távolítsa el.",
            "text": "Biztos, hogy el akarja távolítani ezt a címet?",
            "title": "Cím törlése"
          },
          "addAddress": "Új cím hozzáadása",
          "noAddresses": "Ehhez a fiókhoz nincsenek címek társítva.",
          "otherAddresses": "Egyéb címek",
          "title": "Címek"
        },
        "subscriptions": {
          "subscription": {
            "summary": "{interval} at {amount}",
            "status": {
              "activeMessage": "Addig szerkesztheti tervét vagy rendelhet tételeket. A megrendelését másnap elküldjük.",
              "active": "Megújul {date} {time} {date} ",
              "pausedMessage": "Az előfizetése szünetel. Az alábbiakban folytathatja előfizetését.",
              "paused": "Szünetel {date}",
              "pausedResumesMessage": "Előfizetése szünetel, de a tervek szerint folytatódik. Az alábbiakban még megváltoztathatja, hogy mikor folytatódik az előfizetése.",
              "pausedResumes": "Szünetel. Folytatódik {date} {time}.",
              "trialMessage": "Addig szerkesztheti tervét vagy rendelhet tételeket. A megrendelését másnap elküldjük.",
              "trial": "A próbaidőszak {date} {time}ér véget {date} ",
              "canceledMessage": "Az előfizetése törlésre került, és nem lehet újra aktiválni.",
              "canceled": "Törölték {date}"
            },
            "view": "Előfizetés megtekintése"
          },
          "id": {
            "edit": {
              "contact": "Kapcsolatfelvétel",
              "backToSubscription": "Vissza a",
              "title": "Terv szerkesztése",
              "changeFrequency": "Gyakoriság módosítása",
              "changeOptions": "Opció módosítása",
              "plan": "Terv",
              "popup": {
                "changeFrequency": {
                  "title": "Change frequency",
                  "text": "Changing your subscription frequency will change all future order dates and pricing.",
                  "yes": "Save",
                  "no": "Go back",
                  "loading": "Saving",
                  "success": "Your subscription has been updated."
                },
                "changeOptions": {
                  "title": "Change options",
                  "yes": "Save",
                  "no": "Go back",
                  "loading": "Saving",
                  "success": "Your subscription has been updated."
                }
              }
            },
            "popup": {
              "cancel": {
                "success": "Az előfizetés sikeresen lemondva.",
                "loading": "Törlés",
                "no": "Nincs",
                "yes": "Igen",
                "text": "Biztos, hogy le szeretné mondani ezt az előfizetést?",
                "title": "Előfizetés lemondása"
              },
              "update": {
                "billingAddress": {
                  "success": "Billing address updated."
                },
                "shippingAddress": {
                  "success": "Shipping address updated."
                }
              },
              "pause": {
                "title": "Előfizetés szüneteltetése",
                "message": "Időnként mindannyiunknak szüksége van egy kis szünetre. A következő ciklust kihagyhatja, és folytathatja az előfizetését.",
                "pauseNow": "Előfizetés szüneteltetése most",
                "skipCycle": "Hagyja ki ezt a ciklust",
                "no": "Visszatérés",
                "yes": "Mentés",
                "loading": "Mentés",
                "success": "Az előfizetése szünetel.",
                "skipCycleSuccess": "Az előfizetése kihagyja a következő ciklust."
              },
              "resume": {
                "title": "Folytassa előfizetését",
                "message": "Folytassa előfizetését most, vagy válasszon egy dátumot és időpontot. Ha más dátumot választ, akkor aznap lesz a számlázása.",
                "resumeNow": "Előfizetés folytatása most",
                "chooseDate": "Válasszon dátumot és időpontot",
                "no": "Visszatérés",
                "yes": "Mentés",
                "continue": "Folytassa a",
                "loading": "Mentés",
                "success": "Az előfizetése folytatódott."
              },
              "chooseDate": {
                "title": "Válasszon dátumot és időpontot",
                "message": "Megrendelésének dátumát készül megváltoztatni.",
                "date": {
                  "label": "Resume date",
                  "required": "Please enter a date",
                  "valid": "Please enter a future date"
                },
                "time": {
                  "label": "Resume date",
                  "required": "Please enter a date",
                  "valid": "Please enter a future date"
                },
                "no": "Törölje",
                "yes": "Új dátum mentése",
                "loading": "Mentés",
                "success": "Az előfizetés {date} folytatódik."
              }
            },
            "pause": {
              "title": "Szüksége van egy kis szünetre?",
              "message": "Megértjük. Néha mindannyiunknak szüksége van egy kis szundikálásra és alvásra. Szüntesd meg az előfizetésed a következő számlázási ciklus előtt, és nem kell fizetned.",
              "label": "Előfizetés szüneteltetése"
            },
            "resume": {
              "title": "Előfizetés folytatása",
              "message": "Ön {date} szüneteltette előfizetését. Folytathatja előfizetését most, vagy választhat egy adott dátumot.",
              "label": "Előfizetés folytatása"
            },
            "cancelSubscription": "Előfizetés lemondása",
            "renewal": "{date} {time}",
            "orders": "Megrendelések",
            "editBillingAddress": "Szerkesztés",
            "billingAddress": "Számlázási cím",
            "paymentMethod": "Fizetési mód",
            "deliveryMethod": "Szállítási mód",
            "changeDelivery": "Szállítási adatok módosítása",
            "phoneNumber": "Telefonszám",
            "deliveryAddress": "Szállítási cím",
            "deliveryDetails": "Szállítási adatok",
            "editPlan": "Terv szerkesztése",
            "planRenews": "Terv megújítása",
            "nextOrder": "Következő rendelés",
            "trialEnds": "A próbaidőszak véget ér",
            "freeShipping": "Ingyenes",
            "total": "Összesen",
            "shipping": "Szállítás",
            "plan": "Terv",
            "planItems": "Terv elemek",
            "planTotal": "Terv",
            "backToSubscriptions": "Vissza az összes előfizetéshez"
          },
          "backToProducts": "Vásárlás megkezdése",
          "noSubscriptions": "Jelenleg nincsenek előfizetései.",
          "title": "Előfizetések"
        },
        "orders": {
          "returns": {
            "infoText": "Vegye fel velünk a kapcsolatot, hogy elindíthassuk a visszaküldési folyamatot. Ne felejtse el megadni a rendelés számát és a visszaküldés okát.",
            "title": "Visszatérítés",
            "backToOrders": "Vissza a megrendeléshez | Vissza a megrendelésekhez"
          },
          "id": {
            "orderStatus": {
              "cancelled": "Törölt",
              "complete": "Teljesítve",
              "hold": "Tartva",
              "pendingDelivery": "Kiszállításra vár",
              "pendingPayment": "Fizetésre vár",
              "draft": "Tervezet",
              "pending": "Megrendelés függőben"
            },
            "billingAddress": "Számlázási cím",
            "cashOnDeliveryMessage": "Megrendelése utánvéttel is kifizethető.",
            "cashOnDelivery": "Utánvétel",
            "bankDepositMessage": "A megrendelését banki befizetéssel fizették ki.",
            "bankDeposit": "Banki befizetés",
            "giftCard": "Ajándékkártya",
            "accountCreditMessage": "Rendelését számlaegyenleggel fizette ki.",
            "accountCredit": "Számlahitel",
            "paymentMethod": "Fizetési mód",
            "dateShipped": "Szállítás dátuma",
            "trackingCode": "Nyomon követési kód",
            "carrier": "Szállító",
            "fulfilledDeliveries": "Teljesített szállítások",
            "deliveryMethod": "Szállítási mód",
            "phoneNumber": "Telefonszám",
            "deliveryAddress": "Szállítási cím",
            "deliveryDetails": "Szállítási adatok",
            "taxes": "Adók",
            "discountsAndCredits": "Kedvezmények és jóváírások",
            "shipping": "Szállítás",
            "subtotal": "Részösszeg",
            "quantity": "Mennyiség: {n}",
            "items": "nincs tétel | {n} tétel | {n} tételek",
            "orderSummary": "Rendelési összefoglaló",
            "createReturn": "Visszatérítés létrehozása",
            "total": "Összesen",
            "orderDate": "Megrendelés dátuma",
            "order": "Megrendelés",
            "backToOrders": "Vissza az összes rendeléshez"
          },
          "order": {
            "status": {
              "canceledMessage": "A megrendelését törölték.",
              "canceled": "Törölt",
              "completeMessage": "A megrendelését teljesítették.",
              "complete": "Teljesítve",
              "holdMessage": "Az Ön megrendelése jelenleg várakozás alatt áll.",
              "hold": "Tartva",
              "pendingDeliveryMessage": "A megrendelése kiszállításra vár.",
              "pendingDelivery": "Kiszállításra vár",
              "pendingPaymentMessage": "A megrendelése kifizetésre vár.",
              "pendingPayment": "Fizetésre vár",
              "draftMessage": "A megrendelése jelenleg vázlatos üzemmódban van.",
              "draft": "Tervezet üzemmódban",
              "pendingMessage": "Megkaptuk a megrendelését!",
              "pending": "Megrendelés beérkezett"
            },
            "view": "Megrendelés megtekintése",
            "total": "Összesen",
            "date": "Megrendelés dátuma",
            "title": "Megrendelés"
          },
          "title": "Megrendelések és visszaküldések",
          "backToProducts": "Vásárlás megkezdése",
          "noOrders": "Még nem rendelt semmit."
        },
        "popup": {
          "save": {
            "error": "Hiba történt a fiókja frissítésében.",
            "success": "Fiók frissítve.",
            "loadingLabel": "Mentés",
            "label": "Változások mentése"
          },
          "subscribe": {
            "label": "Fiók létrehozása"
          },
          "confirmPassword": {
            "notMatch": "A jelszavak nem egyeznek.",
            "placeholder": "Új jelszó megerősítése"
          },
          "password": {
            "minLength": "A jelszónak legalább egy karakterből kell állnia {n} ",
            "required": "Kérjük, adja meg jelszavát.",
            "hint": "Legalább {n} karaktert kell tartalmaznia.",
            "placeholder": "Az Ön jelszava",
            "label": "Jelszó"
          },
          "email": {
            "format": "Kérjük, adjon meg egy érvényes e-mail címet.",
            "required": "Kérjük, adja meg az e-mail címét.",
            "placeholder": "E-mail",
            "label": "E-mail"
          },
          "lastName": {
            "maxLength": "A vezetéknév nem haladhatja meg a {n} karaktert.",
            "required": "Kérjük, adja meg a vezetéknevét.",
            "label": "Vezetéknév"
          },
          "firstName": {
            "maxLength": "A keresztnév nem haladhatja meg az {n} karaktert.",
            "required": "Kérjük, adja meg a keresztnevét.",
            "label": "Keresztnév"
          }
        },
        "edit": "Profil szerkesztése",
        "logout": {
          "label": "Kijelentkezés",
          "confirm": "Biztos, hogy ki akarsz jelentkezni?",
          "confirmYes": "Igen",
          "confirmNo": "Nem",
          "success": "Sikeresen kijelentkeztél."
        }
      }
    }
  }
})
